// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__w7ruA","footer":"ModalInfo_footer__ATjpU"};